import { AfterViewInit, Directive, Input } from '@angular/core';
import { AutoComplete } from 'primeng/primeng';

@Directive({
    selector: '[jhiAccessibleAutocomplete]'
})
export class AccessibleAutocompleteDirective implements AfterViewInit {

    private _inputId: string;
    @Input()
    set inputId(inputId: string) {
        this._inputId = inputId;
        if (this.autoComplete && this.autoComplete.input) {
            this.autoComplete.input.id = this._inputId;
        }
    }

    @Input() required: string;
    @Input() ariaDescribedby: string;

    liLength = 0;

    constructor(private autoComplete: AutoComplete) { }

    ngAfterViewInit() {
        this.inputId = this._inputId;
        if (this.autoComplete) {
            this.autoComplete.input.setAttribute('aria-autocomplete', 'list');
            this.autoComplete.input.setAttribute('type', 'text');
            this.autoComplete.input.setAttribute('aria-haspopup', 'listbox');
            this.autoComplete.input.setAttribute('autocapitalize', 'off');
            this.autoComplete.input.setAttribute('autocorrect', 'off');
            this.autoComplete.input.setAttribute('autocomplete', 'off');
            if (this.ariaDescribedby != null) {
                this.autoComplete.input.setAttribute('aria-describedby', this.ariaDescribedby);
            }
            if (this.required != null) {
                this.autoComplete.input.required = true;
            }
            this.autoComplete.inputEL.nativeElement.addEventListener('keyup', this.applyAccessibleOnList);
            this.autoComplete.inputEL.nativeElement.addEventListener('blur', this.removeAccessibleOnList);
        }
    }

    applyAccessibleOnList = () => {
        let ul = this.autoComplete.panel.firstElementChild;
        if (ul && !ul.id) {
            ul.setAttribute('role', 'listbox');
            ul.id = this._inputId + '_' + 'option-list';
            this.autoComplete.input.setAttribute('role', 'combobox');
            this.autoComplete.input.setAttribute('aria-controls', this._inputId + '_' + 'option-list');
            this.autoComplete.input.setAttribute('aria-owns', this._inputId + '_' + 'option-list');
            this.autoComplete.input.setAttribute('aria-expanded', 'true');
        }
        if (ul) {
            if (ul.children.length && (ul.children.length > this.liLength || !ul.children[0].id)) {
                for (let li of ul.children) {
                    li.setAttribute('role', 'option');
                    li.setAttribute('id', this._inputId + '_' + this.cleanString(li.innerText));
                }
            }
            this.liLength = ul.children.length;
            if (this.autoComplete.highlightOption) {
                this.autoComplete.input.setAttribute('aria-activedescendant', this._inputId + '_' + this.cleanString(this.autoComplete.highlightOption));
            }
        }
        this.removeAccessibleOnList();
    }

    removeAccessibleOnList = () => {
        let ul = this.autoComplete.panel.firstElementChild;
        if (!ul) {
            this.autoComplete.input.removeAttribute('role');
            this.autoComplete.input.removeAttribute('aria-controls');
            this.autoComplete.input.removeAttribute('aria-owns');
            this.autoComplete.input.removeAttribute('aria-activedescendant');
            this.autoComplete.input.removeAttribute('aria-expanded');
            this.liLength = 0;
        }
    }


    cleanString(text: string): string {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/accessible-autocomplete.directive.ts